module.exports = __webpack_public_path__ + "img/top-2-1.fb82492f.png";